import React, {useState} from 'react';
import {Dialog} from '@rneui/themed';

import {Address} from '../../../models/mfl';

import AddressPicker from './AddressPicker';
import ManualAddressEntry from './ManualAddressEntry';

// NOTE that the onChange return is different depending on if we are manual or not
// console log the object to see; we should probably unify it to be a proper Address
// all the time, if that's safe depending on usages

type Props = {
  address?: Address;
  onChange: (address: Address) => void;
  placeholder?: string;
  disabled?: boolean;
};
const AddressEntry = ({address, onChange, placeholder, disabled}: Props) => {
  const [isManualEntry, setIsManualEntry] = useState(false);

  const handleManualEntryChange = (enteredAddress: Address) => {
    onChange(enteredAddress);
    setIsManualEntry(false);
  };
  const handleManualEntryCancel = () => setIsManualEntry(false);

  const handleSelectManualEntryDropdownOption = () => setIsManualEntry(true);

  return isManualEntry ? (
    <Dialog
      isVisible={isManualEntry}
      onBackdropPress={handleManualEntryCancel}
      overlayStyle={{height: 400}}>
      <Dialog.Title title={placeholder} />
      <ManualAddressEntry
        address={address}
        onChange={handleManualEntryChange}
        onCancel={handleManualEntryCancel}
      />
    </Dialog>
  ) : (
    <AddressPicker
      address={address}
      onSelect={onChange}
      onManualAddressEntry={handleSelectManualEntryDropdownOption}
      placeholder={placeholder}
      disabled={disabled}
    />
  );
};

export default AddressEntry;
